<app-super-dropdown
  [items]="dropdownItems"
  [userLabel]="user.name"
  (menuAction)="handleDropdownAction($event)"
>
</app-super-dropdown>
<!-- <div class="user-container"></div>
</div> -->
